var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-info"},[_c('span',{staticClass:"main-info__icon icon-info"}),_c('p',{staticClass:"main-info__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }